import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Headphones, Calendar, Check } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const handlePurchaseClick = () => {
    trackAddToCart('Hábitos Atómicos Espirituales', 199, 'MXN');
    window.open('https://pay.hotmart.com/S104255087F?checkoutMode=10&bid=1770183530018', '_blank');
  };
  const goToIntermedio = () => {
    const element = document.getElementById('cta-intermedio');
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const products = [{
    icon: <BookOpen className="w-8 h-8 md:w-10 md:h-10 text-[#0a1628]" data-id="element-206" />,
    title: 'eBook Completo',
    value: '$594 MXN',
    features: ['El sistema ANCLA paso a paso', 'Ejercicios de aplicación inmediata', 'Protocolos de reinicio para cuando fallas', 'Plan de 30 días ejecutable']
  }, {
    icon: <Headphones className="w-8 h-8 md:w-10 md:h-10 text-[#0a1628]" data-id="element-207" />,
    title: 'Audiolibro',
    value: '$394 MXN',
    subtitle: 'Para cuando no tienes energía de leer',
    features: ['Escúchalo manejando o caminando', 'Refuerza tu identidad cada día', 'Formato práctico y digerible']
  }, {
    icon: <Calendar className="w-8 h-8 md:w-10 md:h-10 text-[#0a1628]" data-id="element-208" />,
    title: 'Habit Tracker',
    value: '$194 MXN',
    subtitle: 'Imprimible + digital',
    features: ['Mide sin culpa ni presión', 'Visualiza tu consistencia real', 'Formato simple y minimalista']
  }];
  return <section className="py-16 md:py-32 bg-[#f8fafc] text-[#0a1628]" data-id="element-209">
      <div className="max-w-6xl mx-auto px-5 md:px-6" data-id="element-210">
        <FadeIn data-id="element-211">
          <div className="text-center mb-10 md:mb-16" data-id="element-212">
            <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6 text-[#0a1628]" data-id="element-213">
              Todo lo que recibes hoy
            </h2>
            <p className="text-base md:text-xl text-gray-600" data-id="element-214">
              Un sistema completo para instalar el hábito — sin relleno, sin
              teoría de más.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-215">
          {products.map((product, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-216">
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg md:shadow-xl border border-gray-100 h-full flex flex-col relative" data-id="element-217">
                {/* Value badge */}
                <div className="absolute -top-3 right-4 bg-[#d4af37] text-[#0a1628] text-xs font-bold px-3 py-1 rounded-full" data-id="element-218">
                  Realmente valorado en {product.value} — por ahora en oferta
                </div>
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#f4e4c1] rounded-full flex items-center justify-center mb-5 md:mb-6 mx-auto" data-id="element-219">
                  {product.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-center mb-2 font-serif" data-id="element-220">
                  {product.title}
                </h3>
                {product.subtitle && <p className="text-sm text-gray-500 text-center mb-4 md:mb-6 italic" data-id="element-221">
                    {product.subtitle}
                  </p>}
                <ul className="space-y-3 md:space-y-4 mt-3 md:mt-4 flex-1" data-id="element-222">
                  {product.features.map((feature, i) => <li key={i} className="flex items-start text-gray-700 text-sm md:text-base" data-id="element-223">
                      <Check className="w-4 h-4 text-[#d4af37] mr-2 mt-0.5 flex-shrink-0" data-id="element-224" />
                      <span data-id="element-225">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>

        {/* Value Stack Summary */}
        <FadeIn delay={0.3} data-id="element-226">
          <div className="mt-10 md:mt-16 max-w-lg mx-auto bg-[#0a1628] rounded-2xl p-6 md:p-8 text-center text-white" data-id="element-227">
            <p className="text-gray-300 text-base md:text-lg mb-4" data-id="element-228">
              Todo esto está incluido en nuestros 2 planes
            </p>
            <p className="text-gray-400 text-sm mb-5" data-id="element-229">
              Antes{' '}
              <span className="text-gray-500 line-through" data-id="element-230">$29.99 USD</span> —
              Ahora{' '}
              <span className="text-[#d4af37] font-bold text-2xl" data-id="element-231">
                $7.99 USD
              </span>{' '}
              — pago único
            </p>
            <Button className="w-full shadow-xl" onClick={goToIntermedio} data-id="element-232">
              Quiero ver los planes + los 3 bonos
            </Button>
            <p className="text-gray-500 text-xs mt-3" data-id="element-233">
              Pago único • Garantía de 7 días
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}